const inputCls =
  "rounded-md border border-palette-gray-divider bg-white px-2 py-1.5 text-xs text-palette-slate-heading outline-none focus:ring-2 focus:ring-palette-blue-indicator";

export default function DateRangeInputs({ ranges, onChange, onAdd, onRemove }) {
  return (
    <>
      <div className="space-y-2">
        {ranges.map((range, idx) => (
          <div key={idx} className="flex items-center gap-2 flex-wrap">
            <input
              type="date"
              value={range.start_date}
              onChange={(e) => onChange(idx, "start_date", e.target.value)}
              className={inputCls}
            />
            <span className="text-xs text-palette-gray-placeholder">–</span>
            <input
              type="date"
              value={range.end_date}
              onChange={(e) => onChange(idx, "end_date", e.target.value)}
              className={inputCls}
            />
            {ranges.length > 1 && onRemove && (
              <button
                type="button"
                onClick={() => onRemove(idx)}
                className="text-xs text-palette-red-indicator hover:text-palette-red-badge"
              >
                ✕
              </button>
            )}
          </div>
        ))}
      </div>
      {/* Callers that manage a single fixed range (e.g. editing one vacation request)
          omit onAdd — don't render a button that can't do anything. */}
      {onAdd && (
        <button
          type="button"
          onClick={onAdd}
          className="mt-2 text-xs text-palette-blue-label hover:text-palette-blue-heading"
        >
          + Add another range
        </button>
      )}
    </>
  );
}
